// All display strings are plain text — injectPdfHeader inserts them via
// textContent, which escapes them at render time, so callers pass raw values.
export interface PdfHeaderData {
  /** Content title. */
  title: string;
  /** Source/author display name. */
  sourceName: string;
  /** CDN URL of the source avatar image; non-http(s) or empty renders the colored-initial fallback. */
  sourceAvatarUrl: string;
  /** CSS color for the avatar fallback circle (sanitized to safe CSS color chars on injection). */
  sourceAvatarColor: string;
  /** Pre-formatted publication date, e.g. "June 10, 2026". */
  publishedAtStr: string;
  /** Pre-formatted read time, e.g. "5 min read"; empty string hides it. */
  readTimeStr: string;
  /** Channel names rendered as pills. */
  channels: string[];
  /** Name of the exporting user. */
  exportedBy: string;
  /** Export timestamp in YYYY-MM-DD_HHMM format (shared with the filename). */
  exportedAtStr: string;
  /** Trusted inline SVG markup of the QR code (from generateQrSvg); inserted as raw HTML. */
  qrSvg: string;
  /** Same-origin URL of the Roboto woff2 font asset. */
  robotoFontUrl: string;
}

export type PdfExportErrorCode =
  | 'LOAD_TIMEOUT'
  | 'EMBED_ERROR'
  | 'PRINT_FAILED';

export class PdfExportError extends Error {
  code: PdfExportErrorCode;

  constructor(code: PdfExportErrorCode, message: string) {
    super(message);
    this.name = 'PdfExportError';
    this.code = code;
  }
}

export interface ExportContentToPdfOptions {
  /** Same-origin embed URL, e.g. /embed/article/128?program=5 */
  embedUrl: string;
  headerData: Omit<PdfHeaderData, 'robotoFontUrl'>;
  /** Set as the iframe document title — Chrome uses it as the Save-as-PDF filename suggestion. */
  documentTitle: string;
}
